module.exports = __webpack_public_path__ + "static/media/30OIOS12.7bc3fbe7.jpg";